module.exports = __webpack_public_path__ + "img/doorLogo30.0fe5577b.png";